import moment from "moment"
const formatDate = {}
function format(value,formatString){
    return moment(String(value)).format(formatString)

}
formatDate.install = (Vue) => {
    Vue.filter('format-date', (val,formatString) => {
        return format(val,formatString)
    } )
}

export default formatDate